import { Section } from "../../components/section/Section";

export const ErrorScreen = () => {
  return <Section>Error screen</Section>;
};
